<div class="border-bottom p-3">
  <div class="row align-items-start gx-3 gy-2">
    <div class="col-auto">
      <i class="fa fa-eye"
         [ngStyle]="{
           display: showChecked !== undefined ? 'inline' : 'none',
           color: row?.visible === 1 ? '#00BFFF' : '#999',
           fontSize: '20px',
           cursor: 'pointer'
         }"
         [attr.data-checked]="row?.visible === 1"
         (click)="onCheckboxChange($event)"
         id="checkbox-{{row.id}}">
      </i>
    </div>
    <div class="col-12 col-md-6 col-lg-5">
      <h6 class="text-dark mb-1">
        {{ row.anonyme === false ? row.name : 'Anonyme' }}
      </h6>
      <p class="text-muted mb-1 question-text" style="font-size: 0.8rem;">
        {{ row.question }}
      </p>
    </div>
    <div class="col-12 col-md-4 col-lg-3">
      <div style="font-size: 11px;">
        <strong>{{ 'Speaker' | translate }} :</strong>
        <div *ngFor="let speaker of row.speakers; let i = index" class="text-primary">
          {{ i + 1 }} - {{ speaker }}
        </div>
      </div>
    </div>
    <div class="col-12 col-md-3 col-lg-2 text-md-end">
      <h6 class="text-muted mb-1" style="font-size: 12px !important;">
        {{ row.formattedTimestamp }}
      </h6>
      <p class="mb-0 mt-3" style="font-size: 0.7rem; font-weight: bold; color: rgb(105, 134, 238);">
        {{ truncateText(row.access_name, 24) }}
      </p>
    </div>
  </div>
</div>
